<template>
  <md-tab id="tab-market-area" md-label="Market Area" md-icon="map">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 order-2"
      >
        <PulseLoader :loading="!loaded" :class="{ hide: loaded }"></PulseLoader>
        <div
          :key="componentKey"
          v-if="loaded && searchMarketAreas == null && !searchLoadingMarketArea"
        >
          <div @click="chooseAllUS($event)" class="US-9999 available">
            ALL US
          </div>
          <div
            v-for="(title, stateId) in markets"
            :key="stateId"
            @click="chooseMarket($event)"
            :class="
              `${removeSpaces(Object.keys(title[0])[0])} [${stateId}] ${
                availableMarkets.includes(Object.keys(title[0])[0])
                  ? 'available'
                  : 'unavailable'
              } unclicked correct-padding `
            "
          >
            {{ Object.keys(title[0])[0] }}
          </div>
        </div>
        <!-- <div>
          <pulse-loader
            :color="'blue'"
            :loading="searchLoadingMarketArea && searchMarketAreas == null"
          ></pulse-loader>
        </div> -->
        <div v-if="searchMarketAreas != null">
          <div
            v-if="
              searchMarketAreas[0].states.length == 0 &&
                searchMarketAreas[0].metros.length == 0 &&
                searchMarketAreas[0].counties.length == 0 &&
                searchMarketAreas[0].zips.length == 0
            "
            class="available"
          >
            No results! Please try different keyword.
          </div>
          <div v-if="searchMarketAreas[0].states.length != 0" class="available">
            States:
            <div
              v-for="(searchMarket, searchIndex) in searchMarketAreas[0].states"
              :key="searchIndex + 'collapse'"
              :class="
                `search-${searchMarket.state_id} ${
                  searchMarketAreas[1].states.some(
                    (key) => key.state === searchMarket.state
                  )
                    ? 'available'
                    : 'unavailable'
                } `
              "
              @click="chooseSearchResult($event)"
            >
              {{ searchMarket.state }}
            </div>
          </div>
          <div v-if="searchMarketAreas[0].metros.length != 0" class="available">
            Metro Areas:
            <div
              v-for="(searchMarket, searchIndex) in searchMarketAreas[0].metros"
              :key="searchIndex + 'collapse'"
              :class="
                `search-${searchMarket.metro_id} ${
                  searchMarketAreas[1].metros.some(
                    (key) => key.CBSA_Title === searchMarket.CBSA_Title
                  )
                    ? 'available'
                    : 'unavailable'
                } `
              "
              @click="chooseSearchResult($event)"
            >
              {{ searchMarket.CBSA_Title }}
            </div>
          </div>
          <div
            v-if="searchMarketAreas[0].counties.length != 0"
            class="available"
          >
            Counties:
            <div
              v-for="(searchMarket, searchIndex) in searchMarketAreas[0]
                .counties"
              :key="searchIndex + 'collapse'"
              :class="
                `search-${searchMarket.county_id} ${
                  searchMarketAreas[1].counties.some(
                    (key) => key.county === searchMarket.county
                  )
                    ? 'available'
                    : 'unavailable'
                } `
              "
              @click="chooseSearchResult($event)"
            >
              {{ searchMarket.county }}
            </div>
          </div>
          <div v-if="searchMarketAreas[0].zips.length != 0" class="available">
            Zips:
            <div
              v-for="(searchMarket, searchIndex) in searchMarketAreas[0].zips"
              :key="searchIndex + 'collapse'"
              :class="
                `search-${searchMarket.zip} ${
                  searchMarketAreas[1].zips.some(
                    (key) => key.zip === searchMarket.zip
                  )
                    ? 'available'
                    : 'unavailable'
                } `
              "
            >
              <input
                aria-label="checkbox"
                @change="nextTickInput"
                type="checkbox"
                :id="'checkbox' + searchIndex"
                :value="searchMarket.zip"
                v-model="checkedBoxes"
              />

              {{ searchMarket.zip }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 search_panel"
      >
        <sidebar-map />
        <sidebar-search
          @load-area="loadArea"
          tab="market_area"
          title="Favorite Market Areas"
        />
      </div>
    </div>
  </md-tab>
</template>

<script>
import SidebarSearch from "./SidebarSearch";
import SidebarMap from "./SidebarMap";
import axios from "axios";
import { mapActions } from "vuex";
import { PulseLoader } from "@/components";
import Vue from "vue";
import MarketAreaTabTable from "./MarketAreaTabTable";

export default {
  name: "market-area-tab",
  props: {},
  components: {
    SidebarMap,
    SidebarSearch,
    PulseLoader,
  },
  data() {
    return {
      search: "autofill text area names...",
      apiMarkets: undefined,
      markets: {},
      availableMarkets: [],
      checkedBoxes: [],
      loaded: false,
      componentKey: 0,
      route: "/user/search_reports/imr",
    };
  },
  methods: {
    ...mapActions({
      updatePullTime: "tracking/updatePullTime",
    }),
    nextTickInput: function() {
      this.$nextTick(() => {
        this.chooseSearchResultZips(this.checkedBoxes);
      });
    },
    loadArea: function(e) {
      this.loaded = !e.isLoading;
    },
    removeSpaces: function(name) {
      return name.replace(/\s/g, "").replace(/,/g, " ");
    },
    getData: function(name) {
      if (name && name != "open") {
        return name.split("[")[1].split("]")[0];
      }
    },
    getName: function(name) {
      if (name) {
        return name.split("[")[0];
      }
    },
    chooseSearchResultZips: function(zips) {
      this.$store.commit("C_SET_MARKET_AREA", null);
      this.$store.commit("C_SET_MARKET_AREA", `${zips} [zips]`);
    },
    chooseSearchResult: function(event) {
      this.$store.commit("C_SET_MARKET_AREA", null);
      const id = event.target.className.split(" ")[0].split("-")[1];
      const title = this.getName(event.target.innerText);

      this.$store.commit("C_SET_MARKET_AREA", `${title} [${id}]`);
    },
    getMarkets: async function() {
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + "/info/areas", {
          params: {
            type: "valuation",
            industry: "0",
          },
        })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.apiMarkets = res.data.data;

          this.apiMarkets.forEach((market) => {
            if (Object.keys(this.markets).includes(`${market.state_id}`)) {
              let temp = {};
              temp[market.area] = market.metro_id;
              this.markets[market.state_id].push(temp);
            } else {
              let temp = {};
              temp[market.area] = market.metro_id;
              this.markets[market.state_id] = [temp];
            }
          });
          this.loaded = true;
        });

      await this.getAvailableMarkets();
    },
    getAvailableMarkets: async function() {
      let temp = [];

      await axios
        .get(process.env.VUE_APP_API_BASE_URL + "/info/areas", {
          params: {
            type: "valuation",
            industry: this.getData(this.industry),
          },
        })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.apiMarkets = res.data.data;

          this.apiMarkets.forEach((market) => {
            if (market.metro_id == 0) {
              temp.push(market.area);
            }
          });
        });
      this.availableMarkets = temp;
    },
    // Add request to /user/search_profiles/company (POST)
    chooseMetroArea: async function(item, event) {
      event.stopPropagation();
      this.$store.commit(
        "C_SET_MARKET_AREA",
        `${item.CBSA_Title} [${item.metro_id}]`
      );

      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : "0",
              industry: this.getData(this.mIndustry),
              area: this.getData(this.mMarketArea),
              map_center: "0",
              map_center_zip: "0",
              radius: "0",
              zips: "0",
              type: "company",
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.updatePullTime({ isFinishedDate: false, productId: id });
          this.$store.commit("C_SET_PROFILE_ID", id);
        });

      this.checkedBoxes = [];

      const items = document.querySelectorAll('[name="marketAreaBox"]');
      for (item of items) {
        item.checked = false;
      }
    },
    // Add request to /user/search_profiles/company (POST)
    chooseCounty: async function(item, event) {
      event.stopPropagation();
      this.$store.commit(
        "C_SET_MARKET_AREA",
        `${item.county} [${item.county_id}]`
      );

      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : "0",
              industry: this.getData(this.mIndustry),
              area: this.getData(this.mMarketArea),
              map_center: "0",
              map_center_zip: "0",
              radius: "0",
              zips: "0",
              type: "company",
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.updatePullTime({ isFinishedDate: false, productId: id });
          this.$store.commit("C_SET_PROFILE_ID", id);
        });

      this.checkedBoxes = [];
      const items = document.querySelectorAll('[name="marketAreaBox"]');
      for (item of items) {
        item.checked = false;
      }
    },
    chooseZips: async function(zips) {
      this.$store.commit("C_SET_MARKET_AREA", null);

      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : "0",
              industry: this.getData(this.mIndustry),
              zips: zips,
              area: this.getData(this.mMarketArea),
              map_center: "0",
              map_center_zip: "0",
              radius: "0",
              type: "company",
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.updatePullTime({ isFinishedDate: false, productId: id });
          this.$store.commit("C_SET_PROFILE_ID", id);

          this.$store.commit("C_SET_MARKET_AREA", `${zips} [zips]`);
        });
    },
    async chooseAllUS(event) {
      this.$store.commit("C_SET_MARKET_AREA", null);
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      event.stopPropagation();
      this.$store.commit("C_SET_MARKET_AREA", "US [9999]");
    },
    chooseMarket: async function(event) {
      this.$store.commit("C_SET_MARKET_AREA", null);
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      let query = event.target.className;

      if (!query) {
        return;
      }

      let title = query.split(" ")[0];
      let id = this.getData(query);
      let currentDiv = document.getElementsByClassName(`${title} [${id}]`)[0];
      let availableAreas = [];
      let areas = {};
      this.$store.commit("C_SET_MARKET_AREA", `${title} [${id}]`);

      let loadingDiv = document.createElement("div");
      let loadingMount = document.createElement("div");
      loadingDiv.setAttribute("class", "available");
      loadingDiv.appendChild(loadingMount);
      currentDiv.appendChild(loadingDiv);

      if (title !== "US") {
        const pulseLoader = Vue.extend(PulseLoader);
        const pulseLoaderToMount = new pulseLoader({
          propsData: {
            color: "blue",
            loading: true,
          },
        }).$mount(loadingMount);
      }

      this.$store.commit("C_SET_MARKET_AREA", `${title} [${id}]`);

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : "0",
              industry: this.getData(this.mIndustry),
              area: this.getData(this.mMarketArea),
              zips: "0",
              map_center: "0",
              map_center_zip: "0",
              radius: "0",
              type: "company",
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.updatePullTime({ isFinishedDate: false, productId: id });
          this.$store.commit("C_SET_PROFILE_ID", id);
        });

      //available markets
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + "/info/areas", {
          params: {
            type: "company",
            state_id: id,
            industry: this.getData(this.industry),
          },
        })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          availableAreas = res.data.data;
        });

      await axios
        .get(process.env.VUE_APP_API_BASE_URL + "/info/areas", {
          params: {
            type: "company",
            state_id: id,
          },
        })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          areas = res.data.data;
        });

      while (currentDiv.firstChild != currentDiv.lastChild) {
        currentDiv.removeChild(currentDiv.lastChild);
      }

      if (title !== "US" && currentDiv.classList.contains("unclicked")) {
        currentDiv.classList.remove("unclicked");
        currentDiv.classList.add("clicked");

        let flexDiv = document.createElement("div");
        flexDiv.className = "sub_areas";
        flexDiv.setAttribute("style", "display: flex;");
        currentDiv.appendChild(flexDiv);

        //Metro Areas Scrollable Table
        let tableDiv0 = document.createElement("span");
        let tableMount0 = document.createElement("span");
        tableDiv0.appendChild(tableMount0);
        flexDiv.appendChild(tableDiv0);
        const MarketAreaTable = Vue.extend(MarketAreaTabTable);
        const MarketAreaTableToMount = new MarketAreaTable({
          propsData: {
            data: areas.metros,
            availableData: availableAreas.metros,
            attribute: "CBSA_Title",
            name: "Metro Areas",
            onSelect: this.chooseMetroArea,
          },
        }).$mount(tableMount0);

        //Counties Scrollable Table
        let tableDiv1 = document.createElement("span");
        let tableMount1 = document.createElement("span");
        tableDiv1.appendChild(tableMount1);
        flexDiv.appendChild(tableDiv1);
        const MarketAreaTableToMount1 = new MarketAreaTable({
          propsData: {
            data: areas.counties,
            availableData: availableAreas.counties,
            attribute: "county",
            name: "Counties",
            onSelect: this.chooseCounty,
          },
        }).$mount(tableMount1);

        //Zips Scrollable Table
        let tableDiv2 = document.createElement("span");
        let tableMount2 = document.createElement("span");
        tableDiv2.appendChild(tableMount2);
        flexDiv.appendChild(tableDiv2);
        const MarketAreaTableToMount2 = new MarketAreaTable({
          propsData: {
            data: areas.zips,
            availableData: availableAreas.zips,
            attribute: "zip",
            name: "Zip codes",
            onSelect: this.chooseZips,
          },
        }).$mount(tableMount2);
      } else {
        while (currentDiv.firstChild != currentDiv.lastChild) {
          currentDiv.removeChild(currentDiv.lastChild);
        }
        currentDiv.classList.remove("clicked");
        currentDiv.classList.add("unclicked");
      }
    },
    chooseDefaultMarket: async function() {
      this.$store.commit("C_SET_MARKET_AREA", null);
      this.$store.commit("C_SET_MARKET_AREA", `US [9999]`);
    },
  },
  async created() {
    await this.getMarkets();
  },
  computed: {
    profileId() {
      return this.$store.getters.cProfileId;
    },
    industry() {
      return this.$store.getters.cIndustry;
    },
    marketArea() {
      return this.$store.getters.cMarketArea;
    },
    searchMarketAreas() {
      return this.$store.getters.cSearchMarketAreas;
    },
    searchLoadingMarketArea() {
      return this.$store.getters.cSearchLoadingMarketArea;
    },
  },
  watch: {
    // industry(newValue, oldValue) {
    //   this.getMarkets();
    //   this.componentKey = newValue;
    // },
  },
};
</script>
<style lang="scss">
.unavailable {
  pointer-events: none;
  opacity: 0.5;
  color: #3c4858;
  font-size: 0.9375rem;
  margin: 16px;
}

.available {
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: pointer;
  margin: 16px;
}

.correct-padding {
  padding-left: 16px;
}

.available:hover {
  color: #1a7bfa;
}
</style>
